import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { query } from '@angular/animations';

@Component({
  selector: 'app-supplier-debt-report',
  templateUrl: './supplier-debt-report.component.html',
  styleUrls: ['./supplier-debt-report.component.css']
})
export class SupplierDebtReportComponent implements OnInit {

  // typeList = [{ 'type_id': 'customer', 'type_name': 'تقرير أعمار ديون العملاء' }];
  model = { 'type_id': '0', 'title': 'تقرير أعمار الديون للموردين', 'city_id': '' };
  city_list = [];
  private dp = [];
  displayedColumns = ['acct_number', 'name', 'to_30', 'to_60', 'to_90', 'to_120', 'more_120', 'total'];
  displayedColumns2 = ['acct_number', 'name', 'to_30', 'to_60', 'to_90', 'to_120', 'more_120', 'total'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList) { }

  ngOnInit() {
    let query = this.queryList.all_city;
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city_list = data.data['list'];
      });
  }

  viewRep() {
    // if (this.model['type_id'] == '0') {
    //   alert("الرجاء اختيار نوع التقرير");
    //   (document.getElementById('type_id') as HTMLInputElement).focus();
    //   return false;
    // }
    let obj;
    if (this.model['city_id'] == '')
      obj = { cmd: 'getSuppDebt' };
    else
      obj = { cmd: 'getSuppDebt', city_id: this.model['city_id'] };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        //console.log(data);
        this.applicationConstants.appComp.hideBusyCursor();
        let result = data.data['list'];
        // console.log(data);
        this.dp = result;
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="100%">';
    html_data += '<tr><td width="33%"><h2> تقرير أعمار الديون للموردين</h2></td></tr>';
    // if (this.model['type_id'] != '0') {
    //   this.typeList.forEach(element => {
    //     if (element.type_id == this.model['type_id']) {
    //       html_data += element.type_name;
    //       return;
    //     }
    //   });
    // }
    html_data += '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }


}
